import React, { Component, PureComponent } from 'react';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CardStatus from './CardStatus';

import { COLORS, commonStyles } from '../styles/styles';

import mail from '../assets/closeEnvelope.svg';
import videoContent from '../assets/icon_Video_W.svg';
import journalContent from '../assets/icon_Journal_W.svg';
import iconPipe from '../assets/icon_pipe.png';
import pdfContent from '../assets/icon_PDF_W.svg';
import surveyContent from '../assets/icon_Survey_W.svg';
import surveyContent2 from '../assets/icon_Survey2_W.svg';
import html from '../assets/icon_HTML_W.svg';
import thinktoolContent from '../assets/icon_thinktool_W.svg';
import check from '../assets/check.svg';

import iconVideo from '../assets/icon_video_b.png';
import iconPdf from '../assets/icon_document_b.png';
import iconSurvey2 from '../assets/icon_survey2.svg';
import iconThinktool from '../assets/icon_thinktool_b.png';
import iconHTML from '../assets/icon_html_b.png';
import iconJournal from '../assets/icon_journal_b.png';
import iconCollab from '../assets/collab_icon.png';
import videoBg from '../assets/bg_video.jpg';
import pdfBg from '../assets/bg_document.jpg';
import surveyBg from '../assets/bg_survey.jpg';
import thinktoolBg from '../assets/bg_thinktool.jpg';
import journalBg from '../assets/bg_journal.jpg';
import darkGradient from '../assets/darkGradient.svg'
import placeHolder from '../assets/placeholder.png'
import iconSurvey from '../assets/icon_assessment_b.png';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';
import {getVersionsStatusCard, selectedContentId, selectedModule} from '../redux/selectors'

import {
  MDBBtn, MDBCard, MDBCardBody, MDBCardImage, MDBCardTitle, MDBCardText, MDBRow, MDBCol, MDBIcon, MDBBadge, MDBContainer 
} from "mdbreact";
import { convertTime, getSelectedContent } from '../utils';
import { STORAGE_LINK } from '../constants';



export const getCardTitle = type => {
  switch (type) {
   case 'Collab':
    return iconCollab;
    case 'ThinkTool':
      return iconThinktool;
    case 'Document':
      return iconPdf;
    case 'Video':
      return iconVideo;
    case 'Journal':
      return iconJournal;
    case 'Survey':
        return iconSurvey;
    case 'HTML Captivate':
        return iconHTML;
    case 'HTML Articlulate':
        return iconHTML;
    case 'Form Builder':
          return iconSurvey;
    case 'Poll Builder':
            return iconSurvey;
    default:
      return surveyContent;
  }
};

export const getCardText = type => {
  switch (type) {
    case 'ThinkTool':
      return 'ThinkTool';
    case 'Document':
      return 'Document';
    case 'Video':
      return 'Video';
    case 'Journal':
      return 'Activity';
    case 'Survey':
      return 'Survey';
    case 'HTML Captivate':
      return 'HTML';
    case 'HTML Articlulate':
      return 'HTML';
    default:
      return 'Survey';
  }
};


export const getCardIcon = type => {
  switch (type) {
    case 'ThinkTool':
      return 'brain';
    case 'Document':
      return 'file-pdf';
    case 'Video':
      return 'video';
    case 'Journal':
      return 'pencil-ruler';
    case 'Survey':
      return 'list-ul';
    case 'Assessment':
        return 'vial';
    case 'HTML Captivate':
      return 'code';
    case 'HTML Articlulate':
      return 'code';
    default:
      return 'list-ul';
  }
};

class ContentCard extends PureComponent {

  render () {
   const {
      backgroundImg,
      type,
      name,
      description,
      status,
      handleImageLoaded,
      imageLoadedNow,
      dueDate,
      contentId, 
      onModuleClick, 
      collab,
      item,
      selectedModule,
      versionStatus,
      currentContent
    } = this.props
   return (
     <MDBCard className='z-depth-2 mb-2 componentHolder' onClick={()=>onModuleClick(item)}>
          
          <div style={{position:'relative'}}>
            <div className="compImg">
              <img src={STORAGE_LINK+backgroundImg} className="z-depth-0 rounded-corners" style={{padding: 10, width:'100%'}} alt="" onLoad={handleImageLoaded} />
              
            </div>
            <div className="compPill">

              {status=='exempt' ? <CardStatus className="white-text" status={status}/> :<CardStatus className="white-text" status={status}/>}
            </div>
          </div>
          

          {dueDate!="Invalid date" && <div className='grey-bar grey lighten-2 pt-1 pl-2 pr-2' style={{height:34, bottom:0}}><div style={{width:'55%', position:'absolute', bottom:5, right:5, textAlign:'right'}}>
                  <img className="iconPipe" src={iconPipe}  style={{left:'30%'}}/> 
                  <div style={{display:'inline-block', float:'right', marginTop:7, paddingRight:5}} className="xs-copy-ptsans">{convertTime(item.due_date)}</div>
                </div>
                </div>}

         
          <MDBCardBody style={{position:'relative'}}>
            <div className="compIcon">
                <img src={getCardTitle(collab == 1 ? "Collab" : type)} />
            </div>
            <h6>
              {name}
            </h6>
            <div className="copy">
              {description}
            </div>
          </MDBCardBody>
          
          <ReactCSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}>{((imageLoadedNow || this.props.contentReducer.fetchingItem==true) && contentId==this.props.currentContent) && <div onClick={(e)=>e.stopPropagation() } style={{pointerEvents:'all',backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
            <div style={{position:'absolute', top:"40%", width:'100%'}}>
          <ScaleLoader
           
           height={35}
           width={4}
           radius={2}
           margin='2px'
           color={COLORS.cornerstoneRed}
           loading={true}
         />
         </div>
          </div>}</ReactCSSTransitionGroup>
        </MDBCard>
   );
 
          }
        }

ContentCard.propTypes = {
  classes: PropTypes.instanceOf(Object),
  isSelected: PropTypes.bool,
  isTransparent: PropTypes.bool,
  backgroundImg: PropTypes.string,
  type: PropTypes.string,
  messageCount: PropTypes.number,
  name: PropTypes.string,
  dueDate: PropTypes.string,
  startDate: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.string,
  contentId: PropTypes.number,
  onThinkToolClick: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
  card: {
    borderRadius: 0,
    justifyContent: 'space-between',
    width: 200,
    height: 280,
    backgroundSize: 'cover',
    margin: '5px 5px 10px 5px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    cursor: 'pointer',
    backgroundColor: COLORS.white,
    opacity: 1,
  },
  isTransparent: {
    opacity: 0.4,
  },
  selectedCard: {
    borderColor: COLORS.cornerstoneRed,
  },
  cardContent: {
    padding: 0,
    height: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  cardContentWrapper: {
    padding: 20,
    display: 'flex',
    flex: 2,
    flexDirection: 'column',
  },
  
  fileWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: '15px 15px 30px 15px',
    backgroundColor: '#161616',
    flex: 1,
    backgroundSize: '100%'
  },
  cardIcon:{
    position: 'absolute',
    bottom: 15,
    right: 15,
    height: 50
  },
  cardTitle: {
    fontFamily: 'Gotham-Black',
    color: COLORS.darkGrey,
    fontSize: 16,
    lineHeight: '20px',
    marginBottom: 10,
  },
  itemLeft: {
    flex: 4,
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    marginTop: 28,
    '&:focus': {
      outline: 'none',
    },
  },
  moduleDescription: {
    color: COLORS.darkGrey,
    fontSize: 10,
    lineHeight: '14px',
    fontWeight: 400,
    marginBottom: 10,
    maxHeight: 30,
    overflow: 'hidden',
  },
  cardBottom: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  doneWrapper: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  checkboxChecked: {
    display: 'block',
    width: 28,
    height: 28,
    borderRadius: '50%',
    background: `url(${check}) 0 no-repeat`,
  },
});

const mapStateToProps = state => ({
  userProgramsFull: state.userProgramsFullReducer,
  contentReducer: state.contentListReducer,
  currentContent: selectedContentId(state),
  selectedModule: selectedModule(state),
  versionStatus: getVersionsStatusCard(state)
});

export default compose(
  connect(mapStateToProps, null),
  lifecycle({
   
  }),
  withState('imageLoadedNow', 'toggleImageLoaded', true),
  withHandlers({
    onThinkToolClick: props => (event, contentId) => {
      
      const { openMessages, selectedContentHandler } = props;
      event.stopPropagation();
      openMessages(true);
      
      selectedContentHandler(contentId);
    },
    handleImageLoaded: props => () => {
      props.toggleImageLoaded(false)
    }
  }),
  withStyles(styles),
)(ContentCard);
